import { computed } from 'vue'
import { useSettings } from '@/api/settings'
import { scoreZone, type ScoreZone } from '@/utils/scoreZone'

// Дефолты совпадают с серверными (Tenant.score_threshold_*): жёлтый=1, красный=5.
const DEFAULT_YELLOW = 1
const DEFAULT_RED = 5

/**
 * Цветовые зоны score по порогам тенанта (E2). Пока настройки грузятся — фолбэк к
 * серверным дефолтам. zoneClass даёт CSS-класс `score-green|yellow|red`.
 */
export function useScoreZone() {
  const { data } = useSettings()
  const thresholds = computed(() => ({
    yellow: data.value?.score_threshold_yellow ?? DEFAULT_YELLOW,
    red: data.value?.score_threshold_red ?? DEFAULT_RED,
  }))
  function zoneOf(score: number): ScoreZone {
    return scoreZone(score, thresholds.value.yellow, thresholds.value.red)
  }
  function zoneClass(score: number): string {
    return `score-${zoneOf(score)}`
  }
  return { thresholds, zoneOf, zoneClass }
}
